// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as $$Math from "../Math/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Unscramble from "../Unscramble/index.js";
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var signum = /* #__PURE__ */ Data_Ord.signum(Data_Ord.ordNumber)(Data_Ring.ringNumber);
var sub = /* #__PURE__ */ Data_Numeric.sub(Data_Numeric.additiveNumber);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Foreign_Generic_Class.numberDecode);
var sub1 = /* #__PURE__ */ Data_Numeric.sub(Data_Numeric.additiveInt);
var Money = function (x) {
    return x;
};
var toNumber = function (v) {
    return Data_Int.toNumber(v) / 100.0;
};
var toString = /* #__PURE__ */ (function () {
    var $48 = Data_Number_Format.toStringWith(Data_Number_Format.fixed(2));
    return function ($49) {
        return $48(toNumber($49));
    };
})();
var toCents = function (v) {
    return v;
};
var showMoney = {
    show: toString
};
var semigroupMoney = {
    append: function (v) {
        return function (v1) {
            return add(v)(v1);
        };
    }
};
var scaleIntMoney = {
    scale: function (i) {
        return function (v) {
            return i * v | 0;
        };
    }
};
var roundCents = function (n) {
    var sign = Data_Int.floor(signum(n));
    var abs = $$Math.abs(n);
    var fraction = sub(abs)($$Math.floor(abs));
    var integer = Data_Int.floor(abs);
    var rounded = (function () {
        if (fraction === 0.5 && Data_Int.even(integer)) {
            return integer;
        };
        if (fraction === 0.5 && Data_Int.odd(integer)) {
            return add(integer)(1);
        };
        if (Data_Boolean.otherwise) {
            return Data_Int.round(abs);
        };
        throw new Error("Failed pattern match at Data.Money.Rounded (line 116, column 5 - line 119, column 34): " + [  ]);
    })();
    return sign * rounded | 0;
};
var scaleByFractionAndRound = function (numerator) {
    return function (denominator) {
        return function (v) {
            return roundCents(Data_Int.toNumber(v * numerator | 0) / Data_Int.toNumber(denominator));
        };
    };
};
var ordMoney = Data_Ord.ordInt;
var monoidMoney = {
    mempty: 0,
    Semigroup0: function () {
        return semigroupMoney;
    }
};
var moneyRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(show(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]{0,2})?$")(Data_String_Regex_Flags.noFlags));
var fromNumberWithSimpleRounding = function (n) {
    return Data_Int.round(n * 100.0);
};
var udecodeMoney = {
    unsafeDecode: /* #__PURE__ */ (function () {
        var $50 = Unscramble.unsafeDecode(Unscramble.decodeNumber1);
        return function ($51) {
            return fromNumberWithSimpleRounding($50($51));
        };
    })()
};
var fromNumber = function (n) {
    return roundCents(n * 100.0);
};
var fromString = function (v) {
    if (Data_String_Regex.test(moneyRE)(v)) {
        return map(fromNumber)(Data_Number.fromString(Data_String_Common.replace(",")(".")(v)));
    };
    return Data_Maybe.Nothing.value;
};
var scaleAndRound = function (n) {
    return function (m) {
        return fromNumber(n * toNumber(m));
    };
};
var scaleByPercentAndRound = function (p) {
    return scaleAndRound(p * 1.0e-2);
};
var fromCents = Money;
var eqMoney = Data_Eq.eqInt;
var encodeMoney = {
    encode: /* #__PURE__ */ (function () {
        var $52 = Foreign_Generic_Class.encode(Foreign_Generic_Class.numberEncode);
        return function ($53) {
            return $52(toNumber($53));
        };
    })()
};
var decodeMoney = {
    decode: function (f) {
        return map1(fromNumberWithSimpleRounding)(decode(f));
    }
};
var additiveMoney = {
    zero: 0,
    add: function (v) {
        return function (v1) {
            return add(v)(v1);
        };
    },
    sub: function (v) {
        return function (v1) {
            return sub1(v)(v1);
        };
    }
};
var avgAndRound = function (dictFoldable) {
    var length = Data_Foldable.length(dictFoldable)(Data_Semiring.semiringInt);
    var sum = Data_Numeric.sum(dictFoldable)(additiveMoney);
    return function (f) {
        return scaleByFractionAndRound(1)(length(f))(sum(f));
    };
};
export {
    fromCents,
    toCents,
    fromNumber,
    toNumber,
    roundCents,
    toString,
    fromString,
    scaleByPercentAndRound,
    scaleByFractionAndRound,
    scaleAndRound,
    avgAndRound,
    decodeMoney,
    udecodeMoney,
    encodeMoney,
    showMoney,
    semigroupMoney,
    monoidMoney,
    eqMoney,
    ordMoney,
    additiveMoney,
    scaleIntMoney
};
export {
    scale
} from "../Data.Numeric/index.js";
